import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import TeamBox from './teamBox';
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/person02.png";

const about = () => (
  <div id="about">
    <div className="wrapper">
      <Title title="ABOUT ME" />
      <p className="font12">
        My name is Md. Ariful Islam. You can simply call me Arif. Currently I'm a 12th grade Student. I'm Experienced Graphic Designer over 2 Years with Expert in Photoshop illustrator and Figma and Intermediate Programmer. I specialize in Automation, Web Scraping, Discord Bot, Rest API, Scripting, MERN Stack, Back-End and Web Development with JavaScript, Python and so many Libraries and Framework.
      </p>
      <Row>
      {/*
        <Col md={12} lg={4}>
          <TeamBox avatar={Person01} name="Luke Skywalker" job="Web designer" />
        </Col>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person02} name="Han Solo" job="Graphic Designer" />
        </Col>
        <Col md={12} lg={4}>
          <TeamInfo />
        </Col>
      */
      }
      </Row>
    </div>
  </div>
);

export default about;
